import { memo } from 'react';
import { NotificationPreferencesProvider } from '../preferences';
import TeaseNotificationContainer from './TeaseNotificationContainer';
import ErrorBoundary from '../../components/ErrorBoundary';
import useInterceptAnchorNavigation from '../../hooks/useInterceptAnchorNavigation';
import { jsx as _jsx } from "react/jsx-runtime";
const TeaseNotificationContainerWithProvider = () => {
  useInterceptAnchorNavigation();
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "Notifications - Tease",
    children: /*#__PURE__*/_jsx(NotificationPreferencesProvider, {
      children: /*#__PURE__*/_jsx(TeaseNotificationContainer, {})
    })
  });
};
export default /*#__PURE__*/memo(TeaseNotificationContainerWithProvider);